import React from "react";
import { useUsers } from "../UserContext";
import {useFormatMessage} from "../../intl/intlHooks";
import {userMessages} from "../userMessages";

export const UserLoginStatus = () => {
    const { userData, fetching, fetchError } = useUsers();
    const formatMessage = useFormatMessage();

    return (
        <div id="user-login-status" className="user-login-status">
            <div className="user-login-status__icon-area"><i className="fas fa-user user-icon" /></div>
            {fetching && (<span className="user-login-status__loading">{formatMessage(userMessages.userLoading)}</span>)}
            {!fetchError && !fetching && (<span className="user-login-status__username">{userData.firstName}</span>)}
            {fetchError && (<span className="user-login-status__error">{formatMessage(userMessages.userNotLoggedIn)}</span>)}
        </div>
    );
};
